import React from 'react';
import { PencilIcon, TrashIcon, CalendarIcon, UserIcon, TagIcon } from '@heroicons/react/24/outline';

const BlogCard = ({ post, onEdit, onDelete, onStatusToggle }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group">
            {/* Image Thumbnail */}
            <div className="relative h-48 overflow-hidden">
                <img
                    src={post.image_url ? (post.image_url.startsWith('http') ? post.image_url : `/${post.image_url}`) : '/img/placeholder-blog.jpg'}
                    alt={post.title || 'Blog Post'}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-4 left-4 flex gap-2">
                    <span className="bg-white/90 backdrop-blur-sm text-primary-600 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-sm">
                        {post.category}
                    </span>
                    {post.featured ? (
                        <span className="bg-yellow-400 text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider shadow-sm">
                            Featured
                        </span>
                    ) : null}
                </div>
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
                    <button
                        onClick={() => onEdit(post)}
                        className="p-3 bg-white rounded-xl text-primary-600 hover:text-primary-700 shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-all duration-300"
                    >
                        <PencilIcon className="h-5 w-5" />
                    </button>
                    <button
                        onClick={() => onDelete(post.id)}
                        className="p-3 bg-white rounded-xl text-red-600 hover:text-red-700 shadow-xl transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 delay-75"
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button>
                </div>
            </div>

            <div className="p-5 space-y-4">
                <div className="flex items-center justify-between">
                    <button
                        onClick={() => onStatusToggle(post.id, !post.is_active)}
                        className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider transition-colors ${post.is_active ? 'bg-green-50 text-green-600 hover:bg-green-100' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
                    >
                        {post.is_active ? 'Active' : 'Inactive'}
                    </button>
                    <span className="text-[10px] font-bold text-slate-400 uppercase">Order #{post.display_order}</span>
                </div>

                <div>
                    <h3 className="text-slate-900 font-bold text-lg leading-tight line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {post.title}
                    </h3>
                </div>

                <div className="flex flex-wrap items-center gap-y-2 gap-x-4 border-t border-slate-50 pt-4 text-xs text-slate-500">
                    <div className="flex items-center gap-1.5">
                        <CalendarIcon className="h-4 w-4 text-slate-400" />
                        <span>{post.date}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                        <UserIcon className="h-4 w-4 text-slate-400" />
                        <span>{post.author}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                        <span className="font-medium text-primary-600">{post.read_time}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogCard;
